import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types';
import moment from 'moment'

import { MedicamentoForm } from './components/Medicamento';
import { Empty, PrimaryRoundedButton } from '../..'

export const MultiFormMedicamentos = ({ formsStatus='checked', name, onFormsChange, setFormValidation, value }) => {

    const [elements, setElements] = useState((typeof value !== 'undefined') ? value.map(val => ({
        id: val.id,
        medicamento: val.medicamento,
        text: val.text,
        inicio: val.inicio,
        administracionPrescrita: val.administracionPrescrita,
        modalidadPrescripcion: val.modalidadPrescripcion,
        dosis: val.dosis,
        frecuencia: val.frecuencia,
        tipoFrecuencia: val.tipoFrecuencia,
        diasSemana: val.diasSemana,
        tipoDuracion: val.tipoDuracion,
        duracion: val.duracion,
        dosisRescate: val.dosisRescate,
        contadorDosis: val.contadorDosis,
        contadorDosisDisponibles: val.contadorDosisDisponibles,
        contadorDosisLimite: val.contadorDosisLimite,
        activo: val.activo,
        validation: true
    })) : []);

    const handleAddElement = () => {
        setElements([...elements, { id: moment().unix() + '|||nuevo|||', medicamento: '', text: '', inicio: '', administracionPrescrita: false, modalidadPrescripcion: 'Con horario', dosis: 1, frecuencia: '2', tipoFrecuencia: 'Horas', diasSemana: { lunes: false, martes: false, miercoles: false, jueves: false, viernes: false, sabado: false, domingo: false }, tipoDuracion: 'Días', duracion: 1, dosisRescate: false, contadorDosis: false, contadorDosisDisponibles: 0, contadorDosisLimite: 0, activo: true, validation: false }]);
    }

    const handleRemoveElement = (id) => {
        setElements(elements.filter(element => element.id !== id));
    }

    const handleSetElementData = (data) => {
        setElements(elements.map(element => {
            if(element.id === data.id){
                return data;
            }else{
                return element;
            }
        }));
    }

    useEffect(() => {
        onFormsChange({ target: { name: name, value: elements.map(element => ({
            id: element.id,
            medicamento: element.medicamento,
            text: element.text,
            inicio: element.inicio,
            administracionPrescrita: element.administracionPrescrita,
            modalidadPrescripcion: element.modalidadPrescripcion,
            dosis: element.dosis,
            frecuencia: element.frecuencia,
            tipoFrecuencia: element.tipoFrecuencia,
            diasSemana: element.diasSemana,
            tipoDuracion: element.tipoDuracion,
            duracion: element.duracion,
            dosisRescate: element.dosisRescate,
            contadorDosis: element.contadorDosis,
            contadorDosisDisponibles: element.contadorDosisDisponibles,
            contadorDosisLimite: element.contadorDosisLimite,
            activo: element.activo,
        })) } });
        let errorElements = elements.filter(element => (!element.validation));
        setFormValidation(name, (errorElements.length === 0));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [elements])

    return (
        <>
            {(elements.filter(element => element.activo).length > 0)
            ? elements.filter(element => element.activo).map(element => <MedicamentoForm
                key={element.id}
                element={element}
                removeElement={handleRemoveElement}
                onFormChange={handleSetElementData}
                formStatus={formsStatus}
            />)
            : <Empty />
            }
            <div className='centrar'>
                <PrimaryRoundedButton
                    icon="Plus"
                    onClick={handleAddElement}
                    type="button"
                />
            </div>
        </>
    )
}

MultiFormMedicamentos.propTypes = {
    formsStatus: PropTypes.oneOf(['checked', 'checking']),
    name: PropTypes.string.isRequired,
    onFormsChange: PropTypes.func.isRequired,
    setFormValidation: PropTypes.func,
    value: PropTypes.array,
}